import Agent from './index';
import AgentManage from './AgentManage';

export default {
    path: '/home/agent',
    component: Agent,
    children: [
        {path: '/home/agent/agentManage', component: AgentManage}
    ]
};
